export default __webpack_public_path__ + "static/media/yellow_card_icon.736ee1ee.svg";